module.exports = __webpack_public_path__ + "img/lawnstarter.f9d5c73f.svg";